export const managingCrmContent={
    "how-to-link-folder-in-anydone":{
        title:"How to link a folder in anydone CRM?",
        content:`
        <p>
        In anydone’s automated CRM, the Link Folder allows you to create tickets in your CRM. This streamlines ticket management within your CRM and keeps all customer interactions and their issues created, updated, and managed from one central place.
        </p>

        <ul class="steps-list">
        <li>Open your CRM.</li>
        <li>Click on the Settings.</li>
        <li>Under General, click on the Link option.</li>
        <li>From here select the project and its folder.</li>
        <li>Click on Save button.</li>
        </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/f4e5180c-ead7-47cf-8205-e81b8125cea6.mp4"></video-component>

        <h3 class="headingThree">
        Tips
        </h3>
        <ul class="no-listing">
        <li><i class="fa-solid fa-arrow-right-long"></i> Make sure you have a Ticket or Sprint folder in the project where you have created the CRM Folder.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> Linking a folder to the CRM requires permission.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> Make sure that your support agents are also added to the folder, then only they will be able to create tickets in CRM.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> Once linked, all the tickets created in the CRM will be saved in the task folder that you have linked in the CRM.</li>
        </ul>
       `
    },
    "understanding-anydone-crm":{
        title:"Understanding anydone CRM Leads ",
        content:`
        <p>
        The Leads section contains a list of individuals you have interacted with for the first time. From this section, you can decide whether to convert them into contacts or customers, edit their details, or remove them from the list.
        </p>

        <h3 class="headingThree">
        To view the leads list, follow these steps:
        </h3>
        <ul class="steps-list">
        <li>Open your CRM.</li>
        <li>Click on Leads.</li>
        <li>Here, you will see the list of leads.</li>
        </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/aea5e3c7-b7f2-42ff-9826-6abc1302b023.mp4"></video-component>

        <h3 class="headingThree">
        Search Filter Option
        </h3>
        <p>
        In anydone’s CRM, you can use the search filter to quickly find specific leads. The available filter options are:
        </p>
        <ul class="no-listing">
        <li><i class="fa-solid fa-arrow-right-long"></i> Category: Search leads by category such as VIP or Normal.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> Priority: Filter leads based on priority — High, Medium, or Low.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> Follow Up: Find leads with or without a follow-up.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> Labels: Search leads based on assigned labels.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> Spam: Filter by Spam or Not Spam leads.</li>
        </ul>

        <p class="note">
        Note: All individuals who contact you, regardless of the channel, will be listed in the Lead List by default.
        </p>

        <h3 class="headingThree">
        Converting, Editing, and Deleting Leads
        </h3>
        <ul class="steps-list">
        <li>
            Navigate to the lead you want to make change.
        </li>
        <li>
            Click on the three horizontal dots.
        </li>
        <li>
            Choose one of the following options:
            <ul class="no-listing">
            <li>
            <span class="underline-text">
            Convert to Contact/Customer: 
            </span>
            Convert leads into a Contact or Customer.
            </li>
             <li>
            <span class="underline-text">
            Message:
            </span>
            Click to open the lead's message thread.
            </li>
            <li>
            <span class="underline-text">
            Edit:
            </span>
            Edit the lead’s information.
            </li>
            <li>
            <span class="underline-text">
            Merge:
            </span>
            Merge conversations.
            </li>
            <li>
            <span class="underline-text">
            Delete:
            </span>
            Remove the lead from the lead list.
            </li>
            </ul>
        </li>
        </ul>

        <image-component src="https://edge-a.anydone.com/treeleaf/606cc702-843b-45ab-8339-4cc2ddb96d58.png" alt="leads-automated-crm-ai-platfrom-anydone"></image-component>

        <h3 class="headingThree">
        Adding a Lead Manually in CRM
        </h3>
        <ul class="steps-list">
        <li>Click on the + button at the bottom right corner.</li>
        <li>Enter the required details.</li>
        <li>Then, click on the Add button</li>
        </ul>

        <image-component src="https://edge-a.anydone.com/treeleaf/451b8279-0790-4e56-be05-45db60a5ee9a.png" alt="business-automation-platfrom-anydone"></image-component>
        `
    },
    "managing-crm-contact":{
        title:"Managing CRM Contact List",
        content:`
        <ul class="steps-list">
        <li>Open your CRM.</li>
        <li>Click on Contacts.</li>
        <li>Here, you will see the list of contacts.</li>
        <li>Navigate to the contact you want to make changes.</li>
        <li>Click on the three horizontal dots.</li>
        <li>Choose one of the following options:
            <ul>
                <li><span class="underline-text">Convert to Customer:</span> Convert leads into a Customer.</li>
                <li><span class="underline-text">Message:</span> Click to open the contact’s message thread.</li>
                <li><span class="underline-text">Edit:</span> Edit the contact’s information.</li>
                <li><span class="underline-text">Merge:</span> Merge conversations.</li>
                <li><span class="underline-text">Delete:</span> Remove the contact from the contact list.</li>
            </ul>
        </li>
        </ul>
        <video-component src="https://edge-a.anydone.com/treeleaf/0a4726b5-1f95-4ee2-8443-1c71d6652596.mp4"></video-component>
        
        <h3 class="headingThree">
        Search Filter Option
        </h3>
        <p>
        In anydone’s CRM, you can use the search filter to quickly find specific leads. The available filter options are:
        </p>
        <ul class="no-listing">
        <li><i class="fa-solid fa-arrow-right-long"></i> Category: Search Contacts by category such as VIP or Normal.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> Priority: Filter Contacts based on priority — High, Medium, or Low.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> Follow Up: Find Contacts with or without a follow-up.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> Labels: Search Contacts based on assigned labels.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> Spam: Filter by Spam or Not Spam Contacts .</li>
        <ul>

        <h3 class="headingThree">
        Adding a Contact Manually in CRM
        </h3>
        <ul class="steps-list">
        <li>Open your CRM.</li>
        <li>Click on Contacts.</li>
        <li>Click on the + button at the bottom right corner.</li>
        <li>Enter the required details.</li>
        <li>Click on the Add button.</li>
        </ul>
        `
    },
    "managing-customer":{
        title:'Managing Customer in CRM',
        content:`
        <ul class="steps-list">
        <li>Open your CRM.</li>
        <li>Click on Customer.</li>
        <li>Here, you will see the list of customers.</li>
        <li>Navigate to the contact you want to make changes.</li>
        <li>Click on the three horizontal dots.</li>
        <li>Choose one of the following options:
            <ul class="list-left">
                <li><span class="underline-text">Message:</span> Click to open the customer’s message thread.</li>
                <li><span class="underline-text">Edit:</span> Edit the customer’s information.</li>
                <li><span class="underline-text">Merge:</span> Merge conversations.</li>
                <li><span class="underline-text">Delete:</span> Remove the customer from the customer list.</li>
            </ul>
        </li>
        </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/cbf8e56c-f646-4fcc-8439-7c1f1aac45c4.mp4"></video-component>

        <h3 class="headingThree">Adding a Customer Manually in CRM</h3>
        <ul class="steps-list">
        <li>Open your CRM.</li>
        <li>Click on Customer.</li>
        <li>Click on the + button at the bottom right corner.</li>
        <li>Enter the required details.</li>
        <li>Click on the Add button.</li>
        </ul>

        <h3 class="headingThree">How to Set and Manage Follow Up in CRM</h3>
        <image-component src="https://edge-a.anydone.com/treeleaf/febc155d-86eb-4ee4-8cc3-3e2ac61cce26.png" alt="manage-customer-details-business-ai-agent-platform"></image-component>
        `
    },
    "how-to-set-and-manage-crm":{
        title:"How to Set and Manage Follow Up in CRM",
        content:`
        <h3 class="headingThree">What is a Follow up in Anydone CRM?</h3>
        <p>In anydone, Follow up is where you schedule a reminder to reconnect with a customer later. With this, you can ensure that important conversations, inquired or even sales leads are not forgotten.</p>

        <h3 class="headingThree">How to schedule Follow Up</h3>
        <ul class="steps-list">
            <li>Open your CRM.</li>
            <li>Under the "All Messages" section, navigate to the customer / message thread for which you want to set a follow up.</li>
            <li>Then, click on it which will open the conversation interface.</li>
            <li>Click on the three horizontal dot menu in the top-right corner.</li>
            <li>Select "Follow Up" from the options.</li>
            <li>Under “Follow up Text”. <br> (Here, you can add a relevant follow-up note to remind yourself of the purpose of the follow-up.)</li>
            <li>Now, set the follow up Date and Time according to your preference</li>
            <li>Finally, click on the "Schedule" button.</li>
        </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/995181fa-9b02-48eb-bfe7-b0672d807e38.mp4"></video-component>

        <h3 class="headingThree">Alternative method for scheduling follow up</h3>
        <p>Tips <br> All the schedules follow will have this icon in their thread </p>

        <h3 class="headingThree">View, Reschedule, Delete Follow-Ups </h3>
        <p>Once scheduled, you can View scheduled follow-ups, Edit it, or Delete it at any time following the below steps:</p>
        <ul class="steps-list">
            <li>Open your CRM.</li>
            <li>Under the "All Messages" section, navigate to the customer / message thread where follow up is scheduled.</li>
            <li>Click the information (i) icon from the top-right corner.</li>
            <li>Scroll down to the Follow-Up Section, here you can view:
                <ul class="no-listing">
                    <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Follow-Up Text:</span> The message drafted for the customer.</li>
                    <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Created By:</span> Name of the CRM agent who scheduled it.</li>                    
                    <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Creation Date:</span> When the follow-up was initially set.</li>
                </ul>
            </li>
            <li>Or, Click the horizontal three-dot right to the Follow up then Select:
                <ul class="no-listing">
                    <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Reschedule:</span> Update the date/time of the scheduled follow.</li>
                    <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Delete:</span> Permanently remove the follow-up from the CRM.</li>                    
                </ul>
            </li>
        </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/a6fe5c52-f274-42e7-8e2c-490c48463a7e.mp4"></video-component>
        `
    },
    "how-to-manage-label":{
        title:"Manage Label (add, delete, rename)",
        content:`
        <h2 class="headingTwo">Add New Labels</h2>
        <ul class="steps-list">
            <li>Open your CRM.</li>
            <li>Click on the Settings option from the top navigation bar.</li>
            <li>Select the Labels option.</li>
            <li>Here, you will see all the labels that have already been created.</li>
            <li>Edit Labels : Click on the three horizontal dots next to a label to delete or edit it.</li>
            <li>To create a new label, click the + icon in the bottom-right corner.</li>
            <li>Give the label a name, select a color, </li>
            <li>Finally hit the Create button</li>
        </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/d8e30ef6-5fd2-4925-8d61-273cdbbf7984.mp4"></video-component>

        <h2 class="headingTwo">Alternatively,</h2>
        <ul class="steps-list">
            <li>Open your CRM.</li>
            <li>Under the "All Messages" section, navigate to the customer / message thread where you want to Add Label.</li>
            <li>Then, click on it which will open the conversation interface.</li>
            <li>Click on the three horizontal dot menu in the top-right corner.</li>
            <li>Click "Edit Labels" from the options.</li>
            <li>Select the labels that you want to add, or remove the existing ones.</li>
        </ul>

        <image-component src="https://edge-a.anydone.com/treeleaf/4e98a5b5-c6f7-4cd0-8d3f-8065029502c9.gif" alt="
        Ai-powered-crm-anydone-labels"></image-component>
        <p>
            <strong>Tips:</strong> <br>
            Once you click the Edit Label option, you can either create a new label or select from the labels that have already been created.
        </p>
        `
    },
    "how-to-create-ticket":{
        title:"How to Create a Ticket in anydone CRM?",
        content:`
        <p>In anydone Automated CRM you can create tickets directly from a CRM Message Thread. However, first and foremost, you need to make sure that you have Linked the ticket folder in CRM. Once done, then there are following ways to create ticket in CRM:
        </p>

        <h3 class="headingThree underline-text">Option 1:</h3>
        <ul class="steps-list">
            <li>Open Anydone CRM.</li>
            <li>Go to the "All Messages" section.</li>
            <li>Navigate to the customer or message thread for which you want to create a ticket.</li>
            <li>Click on that specific thread and open the conversation interface.</li>
            <li>Click on the ticket icon from the top-right corner.</li>
            <li>Enter the required ticket details.</li>
            <li>Click on the "Create" button to generate the ticket.</li>
        </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/6860eef9-c748-4943-91f4-200a34a32ead.mp4"></video-component>
        <h3 class="headingThree underline-text">Option 2:</h3>
        <ul class="steps-list">
            <li>Open Anydone CRM.</li>
            <li>Go to the "All Messages" section.</li>
            <li>Navigate to the customer or message thread for which you want to create a ticket.</li>
            <li>Click on the information "i" icon in the top-right corner.</li>
            <li>Scroll down to the "Ticket" section.</li>
            <li>Click on the "+" button next to it.</li>
            <li>Add the required ticket details.</li>
            <li>Click on the "Create" button to save the ticket.</li>
        </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/ce7d1617-3b23-45d9-8cb4-6acfa5fa7f2c.mp4"></video-component>

        <h3 class="headingThree underline-text">Option 3:</h3>
        <ul class="steps-list">
            <li>Open Anydone CRM.</li>
            <li>Go to the "All Messages" section.</li>
            <li>Select the customer or message thread for which you want to create a ticket.</li>
            <li>From the interaction, you can create a ticket for any incoming message.</li>
            <li>Hover over the specific message for which you want to create a ticket.</li>
            <li>Click on the three vertical dots next to the message.</li>
            <li>Select "Create Ticket" from the options.</li>
            <li>Enter the required ticket details.</li>
            <li>Click on the "Create" button.</li>
        </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/5c306a1e-4714-4abb-ab84-b99e2c385d35.mp4"></video-component>

        <h3 class="headingThree underline-text">How to edit/update customer information in anydone CRM?</h3>
        <ul class="steps-list">
            <li>Open Anydone CRM.</li>
            <li>Go to the "All Messages" section.</li>
            <li>Navigate to the customer’s message thread whose information you want to edit.</li>
            <li>Click on the information "i" icon in the top-right corner.</li>
            <li>Navigate to the Info section.</li>
            <li>Click on the pencil-like icon.</li>
            <li>Make changes, update, or edit the information.</li>
            <li>Once you are done, click on the "Update" button.</li>
        </ul>
        <p>
            <strong>Tips:</strong> <br>
            In Crm member with viewer role cannot edit the details, and one needs to be a responder to edit the customer details,
        </p>

        <video-component src="https://edge-a.anydone.com/treeleaf/c9e121d5-15c5-4fd4-9cf5-b3c5335c501d.mp4"></video-component>
        `
    },
    "how-to-open-and-close-conversation":{
        title:"How to Open or Close a Conversation",
        content:`
        <p>
        The Conversation Status in anydone CRM helps track interactions by logging when a conversation is opened or closed and who engaged with the customer and when.
        </p>
        <ol class="steps-list">
            <li>Open Anydone CRM.</li>
            <li>Go to the "All Messages" section.</li>
            <li>Select the message thread whose status you want to change.</li>
            <li>Check the current status at the top right corner of the conversation.</li>
            <li>Click the dropdown icon next to it.</li>
            <li>Choose "Open" or "Close" based on your preference.</li>
        </ol>

        `
    },
    "how-to-add-remove-agents-from-crm":{
        title:"How to add / remove Agents from CRM conversation?",
        content:`
        <ul class="steps-list">
            <li>Open Anydone CRM.</li>
            <li>Go to the "All Messages" section.</li>
            <li>Select the customer's message thread where you want to manage agents.</li>
            <li>Click the "i" icon from the top-right corner.</li>
            <li>Under the "Agents" section:
                <ul>
                    <li>To add an agent: Click the "+ Assign Agent" button and then select the agent you want to add.</li>
                    <li>To remove an agent: Hover over the agent's name, then click the three dots and select Remove option.</li>
                </ul>
            </li>
        </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/a1fdc131-8388-4ab3-b605-9879c2b480b6.mp4"></video-component>
        `
    },
    "understanding-i-button-anydone":{
        title:"Understanding Information (i) Button of anydone CRM",
        content:`
        <p>
        The <strong>Information (i) Button</strong> aims to provide quick access to detailed information with several tools and functionality related to a specific conversation so that you can manage it in a better way. 
        </p>

        <h3 class="underline-text">To access it:</h3>
        <ol class="steps-list">
            <li>Go to the "All Messages" section.</li>
            <li>Navigate to a specific message thread and click on it.</li>
            <li>Now, click on the "i" button from the top-right corner.</li>
        </ol>
        <p>Once opened, the information panel displays several tabs, such as:</p>

        <h3 class="underline-text">Agents:</h3>
        <ul>
            <li><strong>View Assigned Agents:</strong> See the list of agents assigned to the conversation.</li>
            <li><strong>Manage Agents:</strong> Depending on your permissions, you can assign or reassign agents from this section.</li>
        </ul>

        <h3 class="underline-text">Info:</h3>
        <ul>
            <li><strong>Customer Details:</strong> Access detailed information about the customer or depending on your permission you can also make changes to it.</li>
        </ul>

        <h3 class="underline-text">Sources:</h3>
        <ul>
            <li>View all sources from which the customer reached out.</li>
        </ul>

        <h3 class="underline-text">Tickets:</h3>
        <ul>
            <li><strong>View Tickets:</strong>  If a ticket has been created in the conversation, view its details here.</li>
            <li><strong>Create New Tickets:</strong>  You can also create a new ticket directly from here if needed.</li>
        </ul>

        <h3 class="underline-text">Media and Files:</h3>
        <ul>
            <li><strong>Shared Media & Files:</strong>  Browse all media and files shared within the conversation, whether sent by you or the customer.</li>
        </ul>

        <h3 class="underline-text">My Files:</h3>
        <ul>
            <li><strong>Agent Uploads:</strong>  Agents can upload files for internal use (e.g., reference documents). These files are not visible to the customer.</li>
        </ul>

        <h3 class="underline-text">Follow-Up:</h3>
        <ul>
            <li><strong>Scheduled Follow-Ups:</strong>  View any scheduled follow-ups for the conversation.</li>
            <li><strong>Manage Follow-Ups:</strong>  Options to reschedule or delete follow-ups.</li>
        </ul>

        <h3 class="underline-text">Labels:</h3>
        <ul>
            <li><strong>Conversation Labels:</strong>  See all labels that have been applied to the customer.</li>
        </ul>

        <h3 class="underline-text">Notes:</h3>
        <ul>
            <li><strong>Review and Manage Notes:</strong>  View notes added by agents regarding the conversation. Depending on permissions, you can add new notes, edit existing ones, or delete them.</li>
        </ul>

        <h3 class="underline-text">Interaction:</h3>
        <ul>
            <li><strong>Interaction Log:</strong>  Review a chronological log of interactions, including who engaged with the customer, when the conversation was opened or closed, and other relevant activity details.</li>
        </ul>
        `
    },
    "autopilot-crm":{
        title:"What is Autopilot in anydone CRM?",
        content:`
        <p>
        Anydone CRM Autopilot is powered by advanced AI technology that helps manage incoming messages in your CRM. You can think of it as a virtual assistant that works alongside your human agents to handle customer interactions 24/7.
        </p>

        <h3 class="underline-text">By Default, its enable (Full Automation Mode)</h3>
        <ul class="no-listing">
            <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Automatic Responses:</span> When enabled, Autopilot generates and sends human-like, accurate and contextual replies instantly to customer queries.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Work without Intervention:</span> CRM agents will not be able to edit or override responses while Autopilot is enabled.</li>
        </ul>

        <h3 class="underline-text">Disabled Mode (AI Assistant Support)</h3>
        <ul class="no-listing">
            <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">AI Assistance:</span> When disabled, CRM Agents can manually write and send responses.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Smart Suggestions:</span> Autopilot still generates contextual reply suggestions. Agents can:
                <ul>
                    <li><strong>Edit</strong> the suggestion before sending.</li>
                    <li><strong>Ignore</strong> it and write a custom response.</li>
                </ul>
            </li>
        </ul>
        `
    },
    "how-to-run-email-campaign-in-crm":{
        title:"How to Run a Email Campaign in anydone CRM",
        content:`
        <p>To successfully run a campaign in anydone CRM, follow these primary steps. Ensure all required components are created and properly configured before launching the campaign.</p>

        <ol type="1">

          <li>
            <strong>Required</strong> : Make sure you already have created the following
              <ul>
                <li>Project (<a href="#">Learn how to create a project</a>)</li>
                <li>CRM Folder (<a href="#">Learn how to create a CRM Folder</a>)</li>
                <li>CRM (<a href="#">Learn how to create a CRM</a>)</li>
              </ul>
          </li>

          <li>
            <strong>Create an Anydone App for the Campaign</strong> <br> Once you have all the above then you need to create an Anydone App. Here you can learn to create anydone app from the app directory, but by following below steps you can learn to create anydone app specifically for running a CRM Campaign. 
            <ul class="steps-list">
                <li>Go to the App Directory >> Select <strong>Anydone</strong></li>
                <li>Click the <strong>"+"</strong> button on the right-hand side to create a new app.</li>
                <li>Enter a name for the app.</li>
                <li>Under <strong>Type</strong>, select <strong>CRM</strong>.</li>
                <li>Choose the <strong>CRM Folder</strong>.</li>
                <li>Select the specific <strong>CRM</strong> where you want to run the campaign.</li>
                <li>Click on <strong>Create</strong>.</li>
            </ul>
            Once you complete this step, you need to create an AI agent so that you can run and manage your CRM campaign fully automatically.
          </li>

          <li>
            <strong>Create an AI Agent in Flowcess</strong>
              <ul class="steps-list">
                <li>Go to the <strong>Flowcess</strong> folder.</li>
                <li>Click the <strong>"+"</strong> button on the right-hand side to create a new <strong>AI Agent</strong>.</li>
                <li>
                    Add an <strong>Input Block</strong>:
                    <ul>
                    <li>Email: Set the <strong>Type</strong> to <strong>Email</strong></li>
                    <li>Campaign: Set the <strong>Type</strong> to <strong>Json</strong></li>
                    </ul>
                </li>
                <li>
                    Now connect the input block with <strong>Send Mail</strong> and in this block enter <code>$</code> and select the email variable from the input then add the following:
                    <ul>
                    <li>Email Subject</li>
                    <li>Message Body</li>
                    <li>Sender and Receiver information</li>
                    </ul>
                </li>
                <li>Once configured, click <strong>Publish</strong>.</li>
                </ul>
          </li>

           <li>
            <strong>Run the AI Agent</strong>
            <ul class="steps-list">
                <li>Click the <strong>Run</strong> button.</li>
                <li>Choose the <strong>Event Based</strong> option.</li>
                <li>Select <strong>Anydone</strong>.</li>
                <li>Under <strong>Anydone</strong>, select the <strong>Anydone App</strong> that you have created earlier.</li>
                <li>Under <strong>Trigger</strong>, select <strong>On Campaign Create</strong>.</li>
            </ul>

            <p class="underline-text">Now, under Input Mapping configure the following:</p>
            <ul>
                <li><strong>campaign:</strong> Select <strong>Campaign Properties</strong></li>
                <li><strong>email:</strong> Select <strong>Email</strong></li>
                <li><strong>attachment:</strong> Select <strong>Auto Decide</strong></li>
                <li>Finally, click <strong>Run</strong> to initiate the process.</li>
            </ul>
          </li>

           <li>
            <strong>Launch the Campaign from CRM</strong>
            <ul class="steps-list">
                <li>Go back to the <strong>CRM</strong> section.</li>
                <li>Open the <strong>CRM dashboard</strong> where your campaign should run.</li>
                <li>Click on the <strong>Campaigns</strong> tab from the top.</li>
                <li>Click the <strong>"+"</strong> button on the right-hand side to create a new campaign.</li>
                <li>Fill in all the required fields:
                    <ul>
                    <li><strong>Campaign Name</strong></li>
                    <li><strong>Description</strong></li>
                    <li>Other relevant details (target audience, schedule, etc.)</li>
                    </ul>
                </li>
                <li>Click <strong>Submit</strong> to create the campaign.</li>
            </ul>
          </li>

            <li>
            <strong>Track Campaign Status</strong>
                <ul>
                    <li>After submission, the campaign status will initially show as Processing.</li>
                    <li>Once all background operations are complete, the status will change to Completed.</li>
                </ul>
            </li>
        </ol>
        `
      }
}